import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { ONBOARDING_API } from "./apiRoutes";

interface mutateProps {
  data: FieldValues;
  communityId: string
  attachmentId: string
}

const mutateCommitBulkUploadUser = async ({ data, communityId, attachmentId }: mutateProps) => {
  return await axiosAuth.post(`${ONBOARDING_API(communityId)}/occupancy/${attachmentId}/commit`, data);
};

const useCommitBulkUploadUserMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateCommitBulkUploadUser,
    ...queryParams,
  });

export default useCommitBulkUploadUserMutation;
